import React, { RefObject } from 'react';
import * as mobxReact from 'mobx-react';
import OECheckbox from '../../../../../global/oe-checkbox/oe-checkbox';
import './checkbox-filter.scss';
import { ReportConfigurationViewModel } from '../../../_reports/report-configuration/report-configuration.viewmodel';
import Text from '../../../../../global/text/text';
import { IReportFilterItem, IReportOperator } from '../../../../../../api/reports.dao';

interface IProps {
    field: string;
    items: IReportFilterItem[];
    configurationVm: ReportConfigurationViewModel;
    ContentHeader: JSX.Element;
    headerHeight: string;
    headerRef: RefObject<HTMLDivElement>;
}

const CheckboxFilter = mobxReact.observer((props: IProps) => {
    const {
        field,
        items,
        configurationVm,
        ContentHeader,
        headerHeight,
        headerRef,
    } = props;


    const { applyFilter, clearFilter, getAppliedFilter } = configurationVm;

    const appliedFilter = getAppliedFilter(field);


    const isValueSelected = (value: string): boolean => {
        return appliedFilter?.values.includes(value) || false;
    };

    const filterCommonProps: { field: string; customField: boolean; operator: IReportOperator } = {
        field: field,
        customField: false,
        operator: 'IN',
    };

    const selectAll = ({ target: { checked } }: React.ChangeEvent<HTMLInputElement>) => {
        if (checked) {
            applyFilter({ ...filterCommonProps, values: items.map(el => el.value) });
        } else {
            clearFilter(field);
        }
    };

    const selectOne = (value: string) => {
        if (isValueSelected(value)) {
            const newValues = appliedFilter.values.filter(el => el !== value);

            if (newValues.length) {
                applyFilter({ ...filterCommonProps, values: newValues });
            } else {
                clearFilter(field);
            }
        } else {
            applyFilter({ ...filterCommonProps, values: [...(appliedFilter?.values || []), value].filter(el => el !== undefined) });
        }
    };

    return (
        <div className='checkbox-filter'>
            <div className='checkbox-filter__header' ref={headerRef}>
                {ContentHeader}
                <Text className='checkbox-filter__operator' message='Includes:' />
                <OECheckbox
                    checked={appliedFilter?.values.length === items.length}
                    onChange={selectAll}
                    label='Select all'
                    classNames='oe-form-field__checkbox checkbox-filter__checkbox'
                />
            </div>
            <div className='checkbox-filter__items' style={{ height: headerHeight }}>
                {items.map(item => (
                    <OECheckbox
                        key={item.value}
                        checked={isValueSelected(item.value)}
                        onChange={() => selectOne(item.value)}
                        label={item.label || item.value}
                        classNames='oe-form-field__checkbox checkbox-filter__checkbox'
                    />
                ))}
            </div>
        </div>
    );
});

export default CheckboxFilter;
